import React from "react";
import Header from "./Header";
import Projects from "./Projects";

const Home = () => {
  return (
    <main className="content-wrapper">
      <Header />
      <Projects />
    </main>
  );
};

export default Home;